angular.module('wbControllers').controller 'PlanningController',
['$scope', '$location', 'railsResource',
($scope, $location, $resource) ->

  Profile = $resource('/profile')

  Profile.get().$promise
    .then (data) => $scope.clientProfile = data


  $scope.submit = ->
    $scope.clientProfile.planningCompleted = true
    $scope.clientProfile.$update ->
      if analytics && analytics.track
        analytics.track "Created Financial Plan",
          category: 'User'
      $location.path "financial-plans/new"

  if analytics && analytics.track
    analytics.track "Started Financial Plan",
      category: 'User'
]
